export default __webpack_public_path__ + "static/media/\bc_contract.306209cc.webp";